var _circle, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "250 140 300 300",
    enableBackground: "new 0 0 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 11,
    strokeMiterlimit: 10,
    cx: 395.398,
    cy: 284.703,
    r: 123.434,
    className: "svg-circle"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    display: "none",
    fill: "#FFFFFF",
    points: "468.026,287.091 349.269,355.656 349.27,218.525 ",
    className: "svg-shape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 351.22,
    y: 234.019,
    fill: "#FFFFFF",
    width: 34.247,
    height: 101.369,
    className: "svg-shape"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.33,
    y: 234.019,
    fill: "#FFFFFF",
    width: 34.246,
    height: 101.369,
    className: "svg-shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause_icon.bcd97b7bc02e6d141c9e902c895198d7.svg";
export { ForwardRef as ReactComponent };